import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  absolutePosition: {
    position: 'absolute',
    left: '10px',
    top: '10px',
    cursor: 'pointer',
  },
}));

export default useStyles;
